const getTag = (analyticData, device, page) => {
  switch (analyticData.monetizationComponent) {
  case 'brand showcase':
    return analyticData.event === 'click'
      ? {
        event_name: 'monetization link click',
        monetization_page_type: page,
        monetization_site_type: device,
        monetization_page_position: analyticData.position,
      } : {
        event_name: 'monetization view',
        monetization_page_type: page,
        monetization_site_type: device,
        monetization_page_position: analyticData.position,
      };
  case 'sponsored items':
    return analyticData.event === 'click'
      ? {
        event_name: `${page} sponsored items click`,
        product_finding_method: 'sponsored:carousel',
      } : {
        link_name: 'sponsored products count',
        number_of_sponsored_products: analyticData.position,
      };
  case 'google ad':
    return analyticData.event === 'click'
      ? {
        event_name: 'monetization link click',
        monetization_page_type: page,
        monetization_site_type: device,
        monetization_page_position: `${analyticData.position}`,
      } : {
        event_name: 'monetization view',
        monetization_page_type: page,
        monetization_site_type: device,
        monetization_page_position: `${analyticData.position}`,
      };
  case 'sponsored item top':
    return {
      event_name: 'sponsored pdpthumb click',
      product_finding_method: 'sponsored:pdpthumb',
    };
  default:
    return false;
  }
};
export default getTag;
